import { useState } from "react";
import ChatList from "../components/ChatList";
import InviteJoin from "../components/InviteJoin";
import P2P from "../components/p2p";
import Asset from "../pages/Asset";
import Send from "../pages/Send";
import UsdtSend from "../pages/UsdtSend";
import Transaction from "../pages/Transaction";
import Connect from "../pages/connect";
import { Settings } from "../pages/Settings";
import ChatWindow from "../components/ChatWindow";
import { Status } from "../pages/Status";
import About from "../pages/About";
import Help from "../pages/Help";


export default function DesktopChatLayout({
  mobileView,
  isSocialView,
  isPostPage,

  // left panel
  users,
  groups,
  typingUsers,
  groupTyping,
  searchQuery,
  setSearchQuery,
  selectedItem,
  setSelectedItem,
  menuOpen,
  setMenuOpen,
  createGroupMode,
  setCreateGroupMode,
  menuRef,
  activeTab,
  setActiveTab,
  openConnect,
  handleLogout,
  currentUser,
  setAvatarZoom,
  setUsers,
  setGroups,
  groupMembers,
  setGroupMembers,
   searchUsers,

  // right panel state
  inviteToken,
  socket,
  myChatId,
  myUserName,
  myDisplayName,
  handleInviteSuccess,
  handleInviteFailure,
  TABS,
  chatInstances,
activeChatKey,
  // P2P
 p2pEvent,
  p2pOffers,
  setP2pOffers,
  p2pOrders,
  orderTimers,
  wallet,
  activeP2POrder,
  setActiveP2POrder,
  activeP2PPage,
  setActiveP2PPage,
  setMessages,
  getUserKey,
  uuid,
  btc,
   setMyAds,
  myAds, 
   myUsdtAd,
setMyUsdtAd,
 onCreateUsdtAd,
onGetMyUsdtAd,
onUpdateUsdtAd,
onCancelUsdtAd,
onCreateUsdtOrder,
sellerPaymentDetails,
  sellerCurrency,
  loadSellerPaymentDetails,
  refreshOffers,
  clearP2pEvent,
   sendMessage,

  // Assets
  assetView,
  setAssetView,
  sendAsset,
  setSendAsset,
  usdt,
  usdtAddress,
  usdtBalance,
   ghsxWallet,
  uswdSocket,
  usdtSocket,
  buyDataPage,
  onUswdPurchaseSuccess,
 usdtHistory,
   uswdHistory,
   ghsxHistory,
  usdtSendSuccessRef,
    usdtSendErrorRef,
     ghsxSocket,
  // USWD — fetched once in GroupChat
  uswdWallet,
  uswdPricing,
ghsxPricing,
  uswdLoading,
  uswdError,
  isApprovedSeller,
  onRefreshUswdBalance,

  // Connect
  nearbyUsers,
  feedSocket,
  notificationsBadgeCount,
    interactionsBadgeCount,

  // Settings
  uploadToR2,
  settingsSocket,
  theme,
  toggleTheme,
  rentRefundRequest,
setRentRefundRequest,

  // Chat window
  messages,
  typingTimeoutRef,
  getGroupKey,
  input,
    chatMessages,
  chatKey,
  setInput,
  selectedReply,
  setSelectedReply,
  pendingMedia,
  setPendingMedia,
  isUploading,
  setIsUploading,
 uploadProgress,
  setUploadProgress,
  cachedChatList,
   fallbackItem,
  showToast,
  scheduledMessages,
  onConfirmPayment,
  // home tab preference
  setDefaultTab,

  // Status
statusSocket,
statusNotifications,
setStatusNotifications,
myStatusIds,
 hasUnreadStatus,

  // E2EE
  cryptoFns,
}) {

 const [transactionAsset, setTransactionAsset] = useState("uswd");
// Desktop only. Mirrors mobile: every opened chat stays mounted (see
// chatInstances below), toggled by visibility, not by mount/unmount —
// so switching chats no longer discards scroll position/read state.
if (mobileView) return null;
  const handleViewTransactions = (assetType) => {
    setTransactionAsset(assetType);
    setAssetView("transactions");
    setActiveTab(TABS.TRANSACTIONS);
  };

  /* ✅ BUG 3 FIX: openDm finds the user in the users list and selects them,
     then switches to the CHATS tab so the ChatWindow renders immediately.
     Falls back to a minimal item if the user isn't in the list yet
     (e.g. right after following — the socket update may arrive a moment later). */
  const handleOpenDm = (
  sellerChatId,
  sellerUsername
) => {

  const found =
    users.find(
      (u) =>
        String(u.chatId) ===
        String(sellerChatId)
    );

  const item =
    found
      ? {
          ...found,
          type: "user",
        }
      : {
          type: "user",
          chatId: sellerChatId,
          username:
            sellerUsername ||
            sellerChatId,
          online: false,
          unreadCount: 0,
        };

  setActiveTab(
    TABS.CHATS
  );

  setSelectedItem(null);

  setTimeout(() => {

    setSelectedItem(
      item
    );

    if (socket?.connected) {
      socket.emit(
        "select-chat",
        {
          recipientChatId:
            sellerChatId,
        }
      );
    }

  }, 0);

};

 return (
  <div
    className="flex flex-1 h-full min-w-0"
    style={{
      display: isSocialView || isPostPage ? "none" : "flex",
    }}
  >
      {/* LEFT — CHAT LIST */}
      <div className="w-[340px] flex-none border-r border-neutral-200 dark:border-neutral-700">
        <ChatList
          users={users}
          groups={groups}
          typingUsers={typingUsers}
          groupTyping={groupTyping}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          menuOpen={menuOpen}
          setMenuOpen={setMenuOpen}
          mobileView={mobileView}
          createGroupMode={createGroupMode}
          setCreateGroupMode={setCreateGroupMode}
          menuRef={menuRef}
 activeTab={
  activeTab === TABS.CONNECT || activeTab === TABS.BUY_DATA
    ? TABS.CHATS
    : activeTab
}
  setActiveTab={setActiveTab}
  onOpenConnect={openConnect}
          onLogout={handleLogout}
          isLoggedIn={!!currentUser}
          onOpenAvatar={setAvatarZoom}
          setDefaultTab={setDefaultTab}
          cachedChatList={cachedChatList}
           p2pOrders={p2pOrders}
  orderTimers={orderTimers}
  myChatId={myChatId}
    hasUnreadStatus={hasUnreadStatus}
      notificationsBadgeCount={notificationsBadgeCount}
      interactionsBadgeCount={interactionsBadgeCount}
        />
      </div>

      {/* RIGHT — DYNAMIC PANEL */}
      <div className="flex-1 min-w-0 overflow-hidden">
        {inviteToken ? (
          <InviteJoin
            socket={socket}
            chatId={myChatId}
            userName={myUserName}
            inviteToken={inviteToken}
            onSuccess={handleInviteSuccess}
            onFailure={handleInviteFailure}
          />
        ) : activeTab === TABS.P2P ? (
        <P2P
            socket={socket}
            myChatId={myChatId}
              users={users}  
            p2pEvent={p2pEvent}
            offers={p2pOffers}
            setOffers={setP2pOffers}
            p2pOrders={p2pOrders}
             ghsxWallet={ghsxWallet}
              onConfirmPayment={onConfirmPayment}
            orderTimers={orderTimers}
            wallet={wallet}
            setMyAds={setMyAds}   // ← ADD THIS
            myUsdtAd={myUsdtAd}
setMyUsdtAd={setMyUsdtAd}
 myAds={myAds} 
  setP2pOffers={setP2pOffers}
            activeP2POrder={activeP2POrder}
            setActiveP2POrder={setActiveP2POrder}
            activeP2PPage={activeP2PPage}
            setActiveP2PPage={setActiveP2PPage}
            clearP2pEvent={clearP2pEvent}
            onRefreshOffers={refreshOffers}
            sellerPaymentDetails={sellerPaymentDetails}
            sellerCurrency={sellerCurrency}
            loadSellerPaymentDetails={loadSellerPaymentDetails}
            setMessages={setMessages}
            setPendingMedia={setPendingMedia}
            getUserKey={getUserKey}
            uuid={uuid}
            sendMessage={sendMessage}
  onCreateAd={(payload) => {

        if (payload.asset === "USDT") {
            onCreateUsdtAd({
                ...payload,
                userId: currentUser?._id,
            });
            return;
        }

        socket.emit("p2p:create-ad", {
            ...payload,
            userId: currentUser?._id,
        });
    }}

  onUpdateAd={(payload) => {
        socket.emit("p2p:update-ad", payload);
    }}

  onGetMyUsdtAd={onGetMyUsdtAd}

onUpdateUsdtAd={onUpdateUsdtAd}

onCancelUsdtAd={onCancelUsdtAd}

    onCreateOrder={(payload) => {
        if (payload.asset === "USDT") {
            onCreateUsdtOrder(payload);
            return;
        }

        socket.emit("p2p:create-order", payload);
    }}

    onOpenDm={handleOpenDm}
            onBack={() => setActiveTab(TABS.CHATS)}
            mobileView={mobileView}
          />
    // AFTER
) : activeTab === TABS.ASSETS ? (
  <div className="flex h-full flex-col">
    <div className="flex-1 min-h-0 overflow-y-auto h-full">
      {assetView === "list" && (
        <Asset
          wallet={wallet}
          myChatId={myChatId}
          socket={socket}
          usdt={{
            address: usdtAddress,
            balance: usdtBalance?.balance ?? 0,
            committed: usdtBalance?.committed ?? 0,
            available: usdtBalance?.available ?? 0,
          }}
          usdtSocket={usdtSocket}
          ghsxSocket={ghsxSocket}
           ghsxWallet={ghsxWallet}
          currentUser={currentUser}
          onSend={(asset) => {
            setSendAsset(asset);
            setAssetView("send");
          }}
       onTransactions={handleViewTransactions}
onBack={() => setActiveTab(TABS.CHATS)}
mobileView={mobileView}
activeTab={activeTab}
setActiveTab={setActiveTab}
TABS={TABS}
          uswdWallet={uswdWallet}
          uswdPricing={uswdPricing}
ghsxPricing={ghsxPricing}
          uswdLoading={uswdLoading}
          uswdError={uswdError}
          isApprovedSeller={isApprovedSeller}
          onRefreshUswdBalance={onRefreshUswdBalance}
          onUswdPurchaseSuccess={onUswdPurchaseSuccess}
          uswdSocket={uswdSocket}
          usdtSendSuccessRef={usdtSendSuccessRef}
          usdtSendErrorRef={usdtSendErrorRef}
        />
      )}

      {assetView === "send" && sendAsset === "btc" && (
        <Send
          wallet={{ ...wallet, chatId: myChatId }}
          onBack={() => setAssetView("list")}
        />
      )}

      {assetView === "send" && sendAsset === "usdt" && (
        <UsdtSend
          wallet={{ chatId: myChatId }}
          usdtSocket={usdt}
          usdtBalance={usdtBalance}
          socket={socket}
          onBack={() => setAssetView("list")}
        />
      )}
      {assetView === "transactions" && (
  <Transaction
    asset={transactionAsset}
    uswdHistory={uswdHistory}
     ghsxHistory={ghsxHistory}
    usdtHistory={usdtHistory}
    onBack={() => { setAssetView("list"); setActiveTab(TABS.ASSETS); }}
    socket={socket}
  />
)}
    </div>
  </div>
) : activeTab === TABS.TRANSACTIONS ? (
  <div className="flex h-full flex-col">
    <div className="flex-1 min-h-0 overflow-y-auto">
      <Transaction
        asset={transactionAsset}
        uswdHistory={uswdHistory}
         ghsxHistory={ghsxHistory}
        usdtHistory={usdtHistory}
        onBack={() => setActiveTab(TABS.ASSETS)}
        socket={socket}
      />
    </div>
  </div>
) : activeTab === TABS.CONNECT ? (
          <Connect
            users={nearbyUsers}
            searchUsers={searchUsers}
            myChatId={myChatId}
            onFollow={(targetChatId) => feedSocket.followUser({ targetChatId })}
            onUnfollow={(targetChatId) => feedSocket.unfollowUser({ targetChatId })}
            onBack={() => setActiveTab(TABS.CHATS)}
            uploadImage={uploadToR2}
            socket={socket}
            groups={groups}
            groupMembers={groupMembers}
            onOpenGroup={(g) => {
              setActiveTab(TABS.CHATS);
              setSelectedItem({
                type: "group",
                groupId: g.groupId,
                name: g.name,
                groupImageUrl: g.groupImageUrl,
              });
            }}
          />

          ) : activeTab === TABS.STATUS ? (
<Status
  socket={socket}
  myChatId={myChatId}
  currentUser={currentUser}
  users={users}
  mobileView={mobileView}
  onBack={() => setActiveTab(TABS.CHATS)}

  statusSocket={statusSocket}
  statusNotifications={statusNotifications}
  setStatusNotifications={setStatusNotifications}
  myStatusIds={myStatusIds}
  hasUnreadStatus={hasUnreadStatus}

  /* Existing */
  sendMessage={sendMessage}
  selectedReply={selectedReply}
  setSelectedReply={setSelectedReply}

  /* DM reply support */
  setMessages={setMessages}
  setUsers={setUsers}
  getUserKey={getUserKey}
  uuid={uuid}
  showToast={showToast}
  setSelectedItem={setSelectedItem}

  /* Open the DM after replying */
  openDmChat={handleOpenDm}
/>

) : activeTab === TABS.ABOUT ? (

  <About
    onBack={() => setActiveTab(TABS.CHATS)}
  />

) : activeTab === TABS.HELP ? (

  <Help
    onBack={() => setActiveTab(TABS.CHATS)}
  />
) : activeTab === TABS.BUY_DATA ? (
  buyDataPage
) : activeTab === TABS.SETTINGS ? (
         <Settings
  currentUser={currentUser}
  myChatId={myChatId}
  myDisplayName={myDisplayName}
  uploadImage={uploadToR2}
  settingsSocket={settingsSocket}
  socket={socket}
  rentRefundRequest={rentRefundRequest}
  setRentRefundRequest={setRentRefundRequest}
  onBack={() => setActiveTab(TABS.CHATS)}
  theme={theme}
  onToggleTheme={toggleTheme}
/>
             ) : (
          // Same keep-alive pattern as MobileChatPanel: every chat the user
          // has opened stays mounted, and only the active one is shown —
          // switching chats toggles visibility instead of unmounting, so
          // scroll position and the isActive-triggered scroll-to-bottom
          // fix behave the same way on desktop as they do on mobile.
          <div className="relative h-full w-full">
            {Object.values(chatInstances || {}).map((chat) => (
              <div
                key={chat.key}
                className="absolute inset-0"
                style={{
                  display: chat.key === activeChatKey ? "block" : "none",
                }}
              >
                <ChatWindow
                  selectedItem={chat.item}
                  isActive={chat.key === activeChatKey}
                  setSelectedItem={setSelectedItem}
                    activeTab={activeTab}
                  messages={messages}

      setActiveTab={setActiveTab}
      TABS={TABS}

                  setMessages={setMessages}
                  typingUsers={typingUsers}
                  groupTyping={groupTyping}
                  groupMembers={groupMembers}
                  groups={groups}
                  setGroups={setGroups}
                  setGroupMembers={setGroupMembers}
                  users={users}
                  setUsers={setUsers}
                  chatMessages={messages[chat.key] || []}
                  chatKey={chat.key}
                  fallbackItem={chat.item}
                  currentUser={currentUser}
                  socket={socket}
                  input={input}
                  setInput={setInput}
                  showToast={showToast}
                  selectedReply={selectedReply}
                  setSelectedReply={setSelectedReply}
                 
                  mobileView={mobileView}
                  typingTimeoutRef={typingTimeoutRef}
                  getUserKey={getUserKey}
                  getGroupKey={getGroupKey}
                  pendingMedia={pendingMedia}
                  setPendingMedia={setPendingMedia}
                  isUploading={isUploading}
                  setIsUploading={setIsUploading}
                  uploadProgress={uploadProgress}
                  setUploadProgress={setUploadProgress}
                  p2pOrders={p2pOrders}
                    onConfirmPayment={onConfirmPayment}
                  orderTimers={orderTimers}
                  activeP2POrder={activeP2POrder}
                   sellerPaymentDetails={sellerPaymentDetails}
      sellerCurrency={sellerCurrency}
                  feedSocket={feedSocket}
                  cryptoFns={cryptoFns}
                  scheduledMessages={scheduledMessages}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}